module.exports = __webpack_public_path__ + "img/icon_ok.1de88630.svg";